<template>
    <div class="bg-white rounded shadow-sm mb-4">
        <div class="d-flex flex-row flex-wrap align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class="h5 font-weight-semibold mb-0" style="color: #2F2F2F;">Detail Pengiriman</h3>
            <div class="d-flex flex-row align-items-center">
                <div class="d-flex flex-row align-items-center flex-wrap">
                    <div style="width: 170px; margin: 5px 8px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="options.year"
                            class="qtrust-select"
                            placeholder="Semua Tahun"
                        ></MultiSelect>
                    </div>
                    <div style="width: 170px; margin: 5px 8px;">
                        <MultiSelect
                            v-model="filter.month"
                            :options="options.month.map(type => type.value)"
                            :custom-label="opt => options.month.find(x => x.value == opt).title"
                            class="qtrust-select"
                            placeholder="Semua Bulan"
                        ></MultiSelect>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th style="width: 35%;">Tanggal Pengiriman</th>
                        <th style="width: 35%;">Jumlah</th>
                        <th style="width: 30%;">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(dat, idx) in displayData" :key="idx">
                        <td>{{ dat.delivery_at ? (moment(dat.delivery_at).isValid() ? moment(dat.delivery_at).format('DD MMM YYYY | HH:mm') : dat.delivery_at) : '-' }}</td>
                        <td>{{ dat.qty ? numberWithCommas(dat.qty) : 0 }}</td>
                        <td>{{ formatStatus(dat.status) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3">
            <p class="text-muted mb-0" style="font-size: 13px;">Showing {{ totalCount ? (config.page-1)*config.limit+1 : 0 }}-{{ Math.min(config.page*config.limit, totalCount) }} of {{ totalCount }} Items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0" style="font-size: 13px;">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= lastPageCount" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= lastPageCount" @click="goToPage(lastPageCount)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data () {
            return {
                moment: moment,
                options : {
                    year: [...new Set(Array.from({length:5}, (_,i)=>Math.max(parseInt(moment().format('YYYY'))-i, 2024)))],
                    month: Array.from({length: 12}, (_, i) => ({title: moment().month(i).format('MMMM'), value: i + 1})),
                },
                filter : {
                    year: null,
                    month: null,
                },
                config : {
                    lastPage: 1,
                    total: 7,
                    page: 1,
                    limit: 5,
                },
                data : null,
                dummyData: [
                    { delivery_at: '2024-01-01 13:24:00', qty: 1000, status: 'In-Transit' },
                    { delivery_at: '2024-01-12 14:32:00', qty: 1500, status: 'In-Transit' },
                    { delivery_at: '2024-01-20 16:49:00', qty: 500, status: 'In-Transit' },
                    { delivery_at: '2024-02-05 13:21:00', qty: 500, status: 'In-Transit' },
                    { delivery_at: '2024-02-10 09:59:00', qty: 1000, status: 'In-Transit' },
                    { delivery_at: '2024-02-15 11:15:00', qty: 1200, status: 'In-Transit' },
                    { delivery_at: '2024-02-22 15:40:00', qty: 800, status: 'In-Transit' },
                ],
            }
        },
        computed: {
            displayData() {
                if (this.data && this.data.length > 0) {
                    return this.data;
                }
                const start = (this.config.page - 1) * this.config.limit;
                const end = start + this.config.limit;
                return this.dummyData.slice(start, end);
            },
            totalCount() {
                if (this.data && this.data.length > 0) {
                    return this.config.total || this.data.length;
                }
                return this.dummyData.length;
            },
            lastPageCount() {
                if (this.data && this.data.length > 0) {
                    return this.config.lastPage || 1;
                }
                return Math.ceil(this.dummyData.length / this.config.limit) || 1;
            }
        },
        mounted () {
            this.fetchPaginated();
        },
        watch : {
            'filter' : {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.fetchPaginated();
                }
            },
            'config.page' : {
                handler : 'fetchPaginated'
            },
        },
        methods : {
            goToPage(page) {
                if (page >= 1 && page <= this.lastPageCount) this.config.page = page;
            },
            fetchPaginated () {
                let filter = JSON.parse(JSON.stringify(this.filter));

                this.$http.get(`/api/qrs/issue`, {params: {...filter, ...{page: this.config.page, limit: this.config.limit}}})
                .then(async res => {
                    let data = res.data.data;
                    this.data = data;

                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;
                })
                .catch((err)=> {
                    console.log(err);
                });
            },
            formatStatus(status) {
                const map = {
                    'INTRANSIT': 'In-Transit',
                    'RECEIVED': 'Received',
                };
                return map[status] || status;
            },
        },
    }
</script>

<style scoped>
    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 12px 20px;
        font-size: 13px;
        font-weight: 600;
        color: #2F2F2F;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 12px 20px;
        border-bottom: 1px solid #F3F3F3;
        font-size: 13px;
        color: #374151;
    }
</style>